import { Card, CardContent } from '@/components/ui/card'
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts'

const outerData = [
  { name: 'Camada Externa', value: 75 },
  { name: 'Empty', value: 25 }
]

const middleData = [
  { name: 'Camada Média', value: 60 },
  { name: 'Empty', value: 40 }
]

const innerData = [
  { name: 'Camada Interna', value: 45 },
  { name: 'Empty', value: 55 }
]

export function ContextsChart() {
  return (
    <Card className="bg-white h-fit">
      <CardContent className="pt-6 pb-6">
        <div className="flex items-center justify-between gap-8">
          <div className="space-y-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-900">Contextos Ativáveis</h3>
              <p className="text-sm text-gray-600 max-w-[250px]">
                Veja ao lado os contextos com mais expressões salvas durante a semana.
              </p>
            </div>
            <div>
              <p className="text-2xl font-bold text-gray-900">3.210</p>
              <p className="text-sm text-gray-600">contextos totais</p>
            </div>
          </div>
          <div className="w-48 h-48 flex-shrink-0">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={innerData}
                  cx="50%"
                  cy="50%"
                  innerRadius={0}
                  outerRadius={22}
                  paddingAngle={0}
                  dataKey="value"
                  startAngle={90}
                  endAngle={-270}
                >
                  {innerData.map((entry, index) => (
                    <Cell 
                      key={`inner-${index}`} 
                      fill={entry.name === 'Empty' ? '#F5F5F5' : '#F7FF91'} 
                    />
                  ))}
                </Pie>
                <Pie
                  data={middleData}
                  cx="50%"
                  cy="50%"
                  innerRadius={24}
                  outerRadius={59}
                  paddingAngle={0}
                  dataKey="value"
                  startAngle={90}
                  endAngle={-270}
                >
                  {middleData.map((entry, index) => (
                    <Cell 
                      key={`middle-${index}`} 
                      fill={entry.name === 'Empty' ? '#F5F5F5' : '#FCD34D'} 
                    />
                  ))}
                </Pie>
                <Pie
                  data={outerData}
                  cx="50%"
                  cy="50%"
                  innerRadius={61}
                  outerRadius={96}
                  paddingAngle={0}
                  dataKey="value"
                  startAngle={90}
                  endAngle={-270}
                >
                  {outerData.map((entry, index) => (
                    <Cell 
                      key={`outer-${index}`} 
                      fill={entry.name === 'Empty' ? '#F5F5F5' : '#F3FF2C'} 
                    />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
